import { ArrowRight, RotateCcw } from "lucide-react";

export const YellowButton = ({ title, handleClick }) => {
  return (
    <button
      className="p-2 bg-amber-400 rounded-lg shadow capitalize hover:shadow-lg hover:bg-amber-300 space-x-4 font-sans "
      onClick={handleClick}
    >
      <RotateCcw className="inline h-4 w-4" aria-hidden="true" /> {title}
    </button>
  );
};

export const WhiteButton = ({ title, handleClick }) => {
  return (
    <button
      type="button"
      className="p-2 bg-transparent border-2 border-gray-600 hover:border capitalize rounded shadow hover:shadow-lg font-sans w-full h-10  px-2 py-1.5 "
      onClick={handleClick}
    >
      {title}
    </button>
  );
};
export const GreyButton = ({ title, handleClick }) => {
  return (
    <button
      // type="button"
      className="p-2 bg-gray-700 text-white capitalize rounded shadow hover:bg-transparent hover:border-2 border-gray-700 hover:text-gray-800 hover:font-semibold font-sans w-full h-10 px-2 py-1.5 "
      onClick={handleClick}
    >
      {title}
    </button>
  );
};
export const IndigoButton = ({ title, handleClick, hideicon = false }) => {
  return (
    <button
      onClick={handleClick}
      className="w-full p-2 bg-indigo-600 border capitalize rounded-lg hover:bg-indigo-500 shadow hover:shadow-lg space-x-2 text-white font-sans "
    >
      {title} {!hideicon ? <ArrowRight className="inline h-4 w-4" aria-hidden="true" /> : ""}
    </button>
  );
};
export const SkyButton = ({ title, handleClick }) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className="p-2 bg-sky-600 border capitalize rounded-lg hover:bg-sky-500 shadow hover:shadow-lg space-x-2 text-white font-sans "
    >
      {title}
    </button>
  );
};

export const OutlineButton = ({
  title,
  handleClick,
  style = "rounded-full",
}) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`border border-cyan-900 w-full bg-cyan-700 h-10 px-2 py-1.5 text-sm hover:font-semibold text-white shadow-sm hover:bg-white hover:text-cyan-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black ${style}`}
    >
      {title}
    </button>
  );
};
export const BlackOutlineBtn = ({ title, handleClick }) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`mt-4 w-full rounded-sm bg-transparent px-2 py-1.5 text-sm font-semibold shadow-sm hover:bg-white/50 border-2 border-black`}
    >
      {title}
    </button>
  );
};
export const BlackBtn = ({ title, handleClick }) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`mt-4 h-10 w-full rounded-sm bg-black px-2 py-1.5 text-sm text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black`}
    >
      {title}
    </button>
  );
};
